import { Injectable } from "@angular/core";
import { EnvironmentApiService } from "../core/services/environment-api.service";
import { CountryRequest, ICompany, ICompanyDetails, ICountriesResponse, ICountry } from "./member.interface";
import { Observable } from "rxjs";
import { Lookup } from "../insurance-library/insurance-library.interface";

@Injectable({
    providedIn: 'root'

})

export class MembersService extends EnvironmentApiService {
    constructor() {
        super();
    }
    /**
     * get country list
     * @param request class of CountryRequest
     * @returns Observable<ICountriesResponse>
     */
    getCountryList(request: CountryRequest): Observable<ICountriesResponse> {
        return this.httpClient.post<ICountriesResponse>(
            `${this.baseApi}/Country/GetCountryListForWebsite`, request
        );
    }

    /**
     * Get Country By id
     * @param id numbers
     * @returns Observable<IMember> 
     */
    getCountryBy(id: number): Observable<ICountry> {
        return this.httpClient.get<ICountry>(
            `${this.baseApi}/Country/GetCountryById/?id=${id}`, {});
    }

    /**
     * Get list of Companies by Country id
     * @param id numbers
     * @returns Observable<ICompany[]> 
     */
    getListOfCompaniesByCountry(id: number): Observable<ICompany[]> {
        return this.httpClient.get<ICompany[]>(
            `${this.baseApi}/Company/GetCompaniesByCountryId/?id=${id}`);
    }
    /**
     * get company By
     * @param id Company ID
     * @returns  Observable<ICompanyDetails>
     */
    getCompanyBy(id: number): Observable<ICompanyDetails> {
        return this.httpClient.get<ICompanyDetails>(
            `${this.baseApi}/Company/GetCompanyById/?id=${id}`);
    }
    /**
     * get company By
      * @returns  Observable<Lookup>
     */
    getCountryAsLookup(): Observable<Lookup[]> {
        return this.httpClient.get<Lookup[]>(
            `${this.baseApi}/Country/GetCountryAsLookup`);
    }
}